import { staticPath } from  '@/utils/baseUrl.js'
// import Home from './pages/dy/home/home.vue'
import Home from './pages/home/commonHome.vue'
// import SingClass from './pages/dy/courseContent/singleClass/index.vue'
// import CreateClass from './pages/dy/courseContent/singleClass/cearteClass.vue'
// import SpecialColumn from './pages/dy/courseContent/specialColumn/index.vue'
// import CreateColumn from './pages/dy/courseContent/specialColumn/createColumn.vue'
// import Chapter from './pages/dy/courseContent/specialColumn/chapter/index.vue'
// import CreateChapter from './pages/dy/courseContent/specialColumn/chapter/createChapter.vue'
import BasicInfo from './pages/dy/shopManagement/basicInfo.vue'
import Order from './pages/dy/profit/order.vue'
import Marketing from './pages/dy/marketing/marketing.vue'
import CreateMarket from './pages/dy/marketing/createMarket.vue'
import CreateDynamic from './pages/dy/createDynamic/index'
import CreateDynamicList from './pages/dy/createDynamic/list'
import RelationShop from './pages/dy/relation/relation.vue'
import CreateRelation from './pages/dy/relation/createRelation.vue'
import GroupChat from './pages/dy/groupChat/groupChat.vue'
import CreateGroupChat from './pages/dy/groupChat/createGroupChat.vue'
import WithdrawalSettings from './pages/withdrawalSettings/withdrawalSettings.vue'
import WidthawalBind from './pages/withdrawalSettings/widthawalBind.vue'
import GettingUserInformation from './pages/gettingUserInformation/dyGettingUserInformation.vue'

import PrivateMsg from './pages/dy/message/privatemsg/list.vue'
import SmartReply from './pages/dy/message/smartreply/list.vue'
import CardMsg from './pages/dy/message/cardmsg/list.vue'
import CardInfoList from './pages/dy/message/cardmsg/infoList.vue'

import Coupon from './pages/dy/coupon/index.vue'
import addCoupon from './pages/dy/coupon/add.vue'
import couponRecord from './pages/dy/coupon/record.vue'

import MountMini from './pages/dy/mountMini/mountMini.vue'

let list =  {
        path: staticPath + 'home',
        component:Home,
        children:[
        {
            path: staticPath + 'basicInfo', // 基本信息
            component: BasicInfo,
            meta: {
                id: 3,
                title: '基本信息',
                pathName: staticPath + 'basicInfo'
            }
        },
        // {
        //     path: staticPath + 'singClass',
        //     component:SingClass,
        //     meta: {
        //         id: 5,
        //         title: '单课',
        //         pathName: staticPath + 'singClass'
        //     }
        // },
        // {
        //     path: staticPath + 'createClass/:id?', // 新建单课
        //     component:CreateClass,
        //     name: 'CreateClass',
        //     meta: {
        //         title: '新建单课',
        //         saveBtnFlag: true,
        //         pathName: staticPath + 'singClass'
        //         // id: 211
        //     }
        // },
        // {
        //     path: staticPath + 'editClass/:id', // 编辑单课
        //     component:CreateClass,
        //     name: 'EditClass',
        //     meta: {
        //         // id: 212，
        //         title: '编辑单课',
        //         pathName: staticPath + 'singClass'
        //     }
        // },
        // {
        //     path: staticPath + 'preivewClass/:id', // 查看单课
        //     component:CreateClass,
        //     name: 'PreivewClass',
        //     meta: {
        //         // id: 212，
        //         title: '查看单课',
        //         pathName: staticPath + 'singClass'
        //     }
        // },
        // {
        //     path: staticPath + 'createChapter/:product_id/:type?', // 新建章节
        //     component:CreateChapter,
        //     name: 'CreateChapter',
        //     meta: {
        //         // id: 2244,
        //         title: '新建章节',
        //         saveBtnFlag: true,
        //         pathName: staticPath + 'specialColumn'
        //     }
        // },
        // {
        //     path: staticPath + 'editChapter/:product_id/:id/:type?', // 修改章节
        //     component:CreateChapter,
        //     name: 'EditChapter',
        //     meta: {
        //         // id: 2245,
        //         title: '编辑章节',
        //         pathName: staticPath + 'specialColumn'
        //     }
        // },
        // {
        //     path: staticPath + 'preivewChapter/:product_id/:id/:type?', // 修改章节
        //     component:CreateChapter,
        //     name: 'PreivewChapter',
        //     meta: {
        //         // id: 2245,
        //         title: '查看章节',
        //         pathName: staticPath + 'specialColumn'
        //     }
        // },
        {
            path: staticPath + 'order', //  订单统计
            component:Order,
            meta: {
                id: 9,
                title: '订单统计',
                pathName: staticPath + 'order'
            }
        },
        {
            path: staticPath + 'marketing',
            component: Marketing,
            meta: {
                id: 15,
                title: '抢购活动',
                pathName: staticPath + 'marketing'
            }
        },
        {
            path: staticPath + 'createMarket',
            component: CreateMarket,
            meta: {
                title: '添加活动',
                pathName: staticPath + 'marketing'
            }
        },
        {
            path:staticPath + 'createDynamic',
            component:CreateDynamic,
            meta: {
                // id: 345,
                title: '发抖音',
                pathName: staticPath + 'createDynamic/list'
            }
        },
        {
            path:staticPath + 'createDynamic/list',
            component:CreateDynamicList,
            meta: {
                id: 7,
                title: '抖音作品',
                pathName: staticPath + 'createDynamic/list'
            }
        },
        {
            path:staticPath + 'relationShop',
            component: RelationShop,
            meta: {
                id: 16,
                title: '关联商品',
                pathName: staticPath + 'relationShop'
            }
        },
        {
            path:staticPath + 'createRelation',
            component: CreateRelation,
            meta: {
                title: '添加商品',
                pathName: staticPath + 'relationShop'
            }
        },
        {
            path: staticPath + 'groupChat',
            component: GroupChat,
            meta: {
                title: '群聊管理',
                id: 17,
                pathName: staticPath + 'groupChat'
            }
        },
        {
            
            path: staticPath + 'createGroupChat',
            component: CreateGroupChat,
            meta: {
                title: '添加群聊',
                pathName: staticPath + 'groupChat'
            }
        },
        {
            path: staticPath + 'withdrawalSettings',
            component: WithdrawalSettings,
            meta: {
                pathName: staticPath + 'withdrawalSettings'
            }
        },
        {
            path: staticPath + 'widthawalBind/:id?/:status?/:status_type?',
            component: WidthawalBind,
            meta: {
                pathName: staticPath + 'withdrawalSettings'
            }
        },
        {
            path: staticPath + 'gettingUserInformation',
            name: 'GettingUserInformation',
            component: GettingUserInformation,
            meta: {
                pathName: staticPath + 'gettingUserInformation'
            }
        },
		{
		    path: staticPath + 'privatemsg',
		    component: PrivateMsg,
		    meta: {
		        title: '私信对话',
		        pathName: staticPath + 'privatemsg'
		    }
		},
		{
		    path: staticPath + 'smartreply',
		    component: SmartReply,
		    meta: {
		        title: '智能回复',
		        pathName: staticPath + 'smartreply'
		    }
		},
		{
		    path: staticPath + 'cardmsg',
		    component: CardMsg,
		    meta: {
		        title: '卡片管理',
		        pathName: staticPath + 'cardmsg'
		    }
		},
		{
		    path: staticPath + 'cardinfolist/:card_id',
		    component: CardInfoList,
		    meta: {
		        pathName: staticPath + 'cardmsg'
		    }
		},
        {
            
            path: staticPath + 'coupon',
            component: Coupon,
            meta: {
                title: '直播间优惠券',
                pathName: staticPath + 'coupon'
            }
        },
        {
            
            path: staticPath + 'addCoupon',
            component: addCoupon,
            meta: {
                title: '添加优惠券',
                pathName: staticPath + 'coupon'
            }
        },
        {
            
            path: staticPath + 'editCoupon/:id',
            component: addCoupon,
            meta: {
                title: '编辑优惠券',
                pathName: staticPath + 'coupon'
            }
        },
		{ 
            path: staticPath + 'coupon/record/:id',
            component: couponRecord,
            meta: {
                title: '优惠券记录',
                pathName: staticPath + 'coupon'
            }
        },
        { 
            path: staticPath + 'mountMini',
            component: MountMini,
            meta: {
                title: '挂载小程序',
                pathName: staticPath + 'mountMini'
            }
        },
    ]
}

export const dyList = list
